// Plank and long plank: sloped ramps that click onto the end of shelves and other planks
import { definePart } from '../core/registry';
import { Physics } from '../core/physics';
import { block } from '../core/draw-helpers';
import type { Ctx2D, PartDef, Placement } from '../core/types';

export function drawPlank(ctx: Ctx2D, x: number, y: number, a: number, w: number, h: number, sel?: boolean) {
  block(ctx, x, y, w, h, a, '#FFD08A', '#E89A4B', 8, { outline: sel ? '#fff' : null });
  ctx.save(); ctx.translate(x, y); ctx.rotate(a);
  ctx.strokeStyle = 'rgba(160,80,30,.35)'; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(-w / 2 + 14, 2); ctx.bezierCurveTo(-w / 6, -3, w / 6, 5, w / 2 - 14, 0); ctx.stroke();
  ctx.fillStyle = 'rgba(120,60,20,.5)';
  [-w / 2 + 9, w / 2 - 9].forEach(px => { ctx.beginPath(); ctx.arc(px, 0, 2.6, 0, 7); ctx.fill(); });
  ctx.restore();
}

const draw = (ctx: Ctx2D, pl: Placement, sel: boolean) => { const r = Physics.worldRects(pl)[0]; drawPlank(ctx, r.x, r.y, r.a, r.w, r.h, sel); };
const common: PartDef = { rot: true, snap: true, defaultA: 15, thumb: false, draw };

export const plank = definePart({ ...common, rects: [{ x: 0, y: 0, w: 170, h: 18 }], icon: ctx => drawPlank(ctx, 0, 0, -0.35, 100, 16) });
export const long_plank = definePart({ ...common, rects: [{ x: 0, y: 0, w: 260, h: 18 }], icon: ctx => drawPlank(ctx, 0, 0, -0.35, 110, 14) });
